import React from 'react';
import PropTypes from 'prop-types';
// import cn from 'classnames';
import Collegeview from './collegeview';
import PostingView from './postingview';
// import styles from '../DashboardView.scss';

const Default = props => (
    props.showSchools ? <Collegeview {...props} /> : <PostingView {...props} />
  );


Default.propTypes = {
  showSchools: PropTypes.bool.isRequired,
};

export default Default;



// WEBPACK FOOTER //
// ./src/components/DashboardView/Default/Default.js